var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 171,
    viewBox: "0 0 300 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_780_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.58 62.8231C222.58 62.8231 222.572 62.8303 222.569 62.8343C219.949 51.2796 214.548 19.6137 179.293 5.34884C172.186 2.47319 141.577 -8.85468 108.238 14.0024C103.136 17.5004 93.202 27.4262 84.7817 42.3021C78.1617 39.6247 71.0396 38.1675 63.6202 38.1675C28.4833 38.1675 0 70.842 0 111.147C0 130.517 6.58018 148.125 17.3143 161.19H97.4226C97.7579 161.372 98.0924 161.543 98.4278 161.7C100.959 162.889 269.44 162.359 270.666 161.698C336.881 126.051 277.903 -3.61433 222.58 62.8231Z",
    fill: "#F7FAFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_780_1090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.694 151.799L150.934 160.309C148.552 159.552 144.244 157.823 140.421 153.856C134.884 148.109 133.934 141.369 133.497 138.263C133.169 135.932 132.269 128.936 135.434 121.93C136.224 120.184 136.857 119.343 140.305 112.446C142.554 107.948 142.816 107.245 143.04 106.261C144.248 100.945 142.308 96.4072 141.645 94.9113C140.135 91.5059 129.783 83.4771 125.417 80.4476C124.512 79.8194 119.476 76.2642 115.622 70.5307C113.967 68.0702 108.314 59.66 110.085 48.84C111.027 43.0772 113.711 38.8623 115.555 36.4697L151.414 26.8611C154.207 28.0114 158.64 30.3209 162.336 34.8393C169.279 43.3245 168.588 53.4347 168.387 56.3924C167.916 63.2849 165.333 68.8799 164.862 69.8782C162.596 74.6834 157.645 86.8129 158.04 90.5184C158.214 92.1454 158.804 97.0446 162.507 101.045C163.193 101.785 163.772 102.263 167.968 105.034C174.404 109.281 175.373 109.694 176.928 110.812C183.172 115.295 185.891 121.804 186.773 123.988C187.947 126.897 190.496 133.208 188.573 140.954C187.246 146.3 184.379 149.952 182.694 151.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.144 159.449C150.811 158.27 144.713 154.45 142.361 152.01C137.42 146.882 136.564 140.805 136.153 137.885C135.366 132.295 135.948 127.293 137.881 123.016C138.19 122.33 138.479 121.79 139.003 120.81C139.701 119.503 140.756 117.528 142.707 113.627C145.033 108.976 145.362 108.139 145.657 106.841C146.604 102.672 146.082 98.2956 144.103 93.8308C143.566 92.6211 142.178 90.4417 136.347 85.5083C132.798 82.5048 129.072 79.7286 126.96 78.2628C125.682 77.3764 121.246 74.0896 117.856 69.0471C117.052 67.8496 115.377 65.3592 114.088 61.8903C112.512 57.6517 112.057 53.4028 112.734 49.2614C113.343 45.5388 116.006 38.951 118.329 35.7291L148.788 27.5676C152.411 29.1964 157.868 33.607 160.257 36.5276C162.915 39.7755 164.645 43.684 165.399 48.1428C166.016 51.7917 165.812 54.7857 165.714 56.2249C165.3 62.288 163.103 67.3508 162.438 68.7579C161.342 71.0834 159.503 75.3507 157.931 79.7263C155.348 86.9156 155.236 89.4957 155.376 90.8117C155.894 95.6678 157.629 99.7209 160.535 102.856C161.439 103.832 162.141 104.392 166.483 107.258C170.123 109.661 172.024 110.843 173.282 111.626C174.226 112.214 174.746 112.538 175.357 112.976C179.17 115.713 182.174 119.756 184.288 124.989C185.393 127.723 187.69 133.413 185.974 140.325C185.157 143.615 181.462 150.059 179.166 152.745L154.144 159.45L154.144 159.449Z",
    fill: "#9DBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.706 108.127C154.151 108.045 153.194 99.8771 155.348 89.5605C155.436 87.9469 155.979 85.1468 157.928 79.7245C159.5 75.3489 161.338 71.0816 162.435 68.7561C162.759 68.0688 163.449 66.5079 164.119 64.3845C156.197 66.6273 150.774 66.4863 146.973 65.5976C146.086 65.3906 143.905 64.8185 140.607 64.2155C136.502 63.4648 130.643 62.4256 123.314 62.6732C120.966 62.7529 118.067 62.9776 114.751 63.5293C115.904 66.1468 117.182 68.0471 117.853 69.0467C121.243 74.0891 125.677 77.375 126.957 78.2624C129.069 79.7282 132.795 82.5043 136.344 85.5078C141.558 89.9186 143.217 92.1272 143.894 93.4097C150.597 101.355 153.313 108.2 153.704 108.128L153.706 108.127Z",
    fill: "url(#paint0_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.447 111.988C156.644 112.725 156.203 113.483 155.461 113.682C154.718 113.881 153.957 113.445 153.76 112.707C153.562 111.97 154.003 111.212 154.746 111.013C155.488 110.814 156.249 111.25 156.447 111.988Z",
    fill: "url(#paint1_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.861 117.79C153.975 118.214 153.721 118.65 153.294 118.764C152.867 118.879 152.429 118.628 152.316 118.204C152.202 117.78 152.456 117.344 152.883 117.229C153.31 117.115 153.748 117.366 153.861 117.79Z",
    fill: "url(#paint2_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.724 119.528C159.897 120.171 159.511 120.834 158.863 121.007C158.216 121.181 157.552 120.799 157.379 120.156C157.207 119.513 157.593 118.85 158.239 118.677C158.885 118.504 159.552 118.884 159.724 119.528Z",
    fill: "url(#paint3_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35 123.346C155.464 123.77 155.21 124.206 154.783 124.321C154.356 124.435 153.918 124.184 153.805 123.76C153.691 123.336 153.945 122.9 154.372 122.786C154.799 122.671 155.236 122.922 155.35 123.346Z",
    fill: "url(#paint4_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.602 133.187C161.761 133.781 161.406 134.391 160.808 134.551C160.211 134.712 159.598 134.36 159.439 133.767C159.28 133.173 159.635 132.563 160.233 132.403C160.83 132.243 161.443 132.594 161.602 133.187Z",
    fill: "url(#paint5_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.373 124.907C163.647 125.929 163.034 126.981 162.006 127.257C160.977 127.532 159.92 126.927 159.647 125.905C159.373 124.884 159.986 123.831 161.014 123.556C162.043 123.28 163.1 123.885 163.373 124.907Z",
    fill: "url(#paint6_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.107 128.325C168.224 132.467 157.168 144.255 150.081 146.815C147.618 147.704 144.416 148.858 140.22 149.393C140.832 150.279 141.539 151.157 142.361 152.008C144.712 154.449 150.811 158.269 154.143 159.447L179.163 152.743C181.459 150.057 185.154 143.613 185.97 140.323C187.504 134.143 185.83 128.941 184.669 125.953C182.292 126.377 179.723 127.104 177.107 128.323L177.107 128.325Z",
    fill: "url(#paint7_linear_780_1090)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M157.929 79.7242C159.501 75.3486 161.34 71.0813 162.436 68.7558C163.1 67.349 165.297 62.2862 165.712 56.2228C165.81 54.7836 166.016 51.7906 165.397 48.1407C164.643 43.6819 162.913 39.7747 160.255 36.5255C157.866 33.6049 152.409 29.1943 148.786 27.5655L146.731 28.1161C149.36 31.1877 152.12 35.3015 154.032 40.5461C158.657 53.2428 155.31 64.3521 153.741 69.2975C150.889 78.2862 145.93 85.0291 141.102 89.8679C143.068 91.891 143.759 93.0581 144.101 93.8287C145.68 97.3925 146.332 100.899 146.05 104.289C147.615 104.508 149.251 104.836 150.96 105.334C153.488 106.071 161.577 108.427 167.557 115.886C167.557 115.886 174.03 123.96 174.095 135.309C174.135 142.522 171.096 149.809 165.692 156.356L179.166 152.745C181.462 150.059 185.157 143.615 185.974 140.325C187.689 133.414 185.391 127.723 184.288 124.989C182.174 119.755 179.17 115.713 175.357 112.976C174.746 112.537 174.226 112.213 173.282 111.626C172.024 110.843 170.123 109.661 166.483 107.258C162.143 104.393 161.439 103.832 160.535 102.856C157.63 99.7194 155.894 95.668 155.376 90.8119C155.236 89.4959 155.348 86.9158 157.931 79.7265L157.929 79.7242Z",
    fill: "#A0A0F9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.317 141.962C142.469 142.299 141.514 141.854 141.236 140.991C140.09 137.443 138.839 130.964 141.711 124.179C142.754 121.715 144.223 119.465 146.09 117.475C146.717 116.807 147.775 116.797 148.399 117.462L148.447 117.513C149.007 118.109 149.013 119.041 148.451 119.639C146.838 121.357 145.57 123.292 144.674 125.411C142.194 131.27 143.297 136.913 144.298 140.005C144.552 140.787 144.149 141.631 143.38 141.938L143.316 141.963L143.317 141.962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.002 149.8L144.474 161.731C142.533 162.251 141.38 164.235 141.896 166.161C142.412 168.088 144.404 169.228 146.343 168.709L190.871 156.777C192.812 156.257 193.965 154.273 193.449 152.347C192.933 150.42 190.941 149.28 189.002 149.8Z",
    fill: "#669AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.002 149.8L180.506 152.076C182.447 151.556 184.438 152.698 184.954 154.624C185.47 156.551 184.316 158.534 182.376 159.054L190.871 156.777C192.812 156.257 193.965 154.273 193.449 152.347C192.933 150.42 190.941 149.28 189.002 149.8Z",
    fill: "#2E75FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M151.414 26.8613L115.556 36.4694C114.563 37.7591 113.326 39.5787 112.247 41.8853L156.986 29.8974C154.901 28.4401 152.919 27.4817 151.413 26.8616L151.414 26.8613Z",
    fill: "#6F6FEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.955 26.8752L109.033 40.2519C106.858 40.8346 104.626 39.5565 104.048 37.3967C103.469 35.2369 104.762 33.0143 106.937 32.4316L156.86 19.0549C159.034 18.4722 161.266 19.7503 161.844 21.9101C162.423 24.0699 161.13 26.2925 158.955 26.8752Z",
    fill: "#669AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.86 19.055L147.121 21.6646C149.295 21.0818 151.527 22.3599 152.105 24.5197C152.684 26.6796 151.391 28.9021 149.216 29.4848L158.955 26.8753C161.13 26.2925 162.423 24.07 161.844 21.9102C161.266 19.7504 159.034 18.4723 156.86 19.055Z",
    fill: "#2E75FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.466 31.9257L108.206 36.2827C107.636 36.4352 107.045 36.0966 106.894 35.5312C106.742 34.9659 107.085 34.3771 107.654 34.2246L123.915 29.8676C124.484 29.7151 125.075 30.0536 125.227 30.619C125.378 31.1844 125.035 31.7732 124.466 31.9257Z",
    fill: "#9DBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.108 160.877L145.847 165.234C145.278 165.386 144.687 165.048 144.535 164.482C144.384 163.917 144.727 163.328 145.296 163.176L161.556 158.819C162.126 158.666 162.717 159.005 162.868 159.57C163.02 160.136 162.677 160.724 162.108 160.877Z",
    fill: "#9DBEFF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.432 81.6548C138.864 82.3111 137.868 82.3852 137.211 81.8208C135.944 80.7331 134.672 79.6354 133.414 78.5468C126.879 72.8833 126.184 72.1491 125.627 71.5606C122.751 68.5172 120.267 65.8881 118.962 61.7142C118.375 59.8383 118.093 57.8751 118.116 55.8599C118.127 54.9437 118.92 54.2272 119.838 54.3098L119.906 54.3155C120.727 54.39 121.34 55.0809 121.331 55.9002C121.314 57.5768 121.548 59.2047 122.034 60.7552C123.067 64.0603 124.964 66.1812 127.975 69.3658C128.429 69.8473 129.116 70.5734 135.532 76.1332C136.787 77.2199 138.055 78.3143 139.318 79.3988C139.973 79.9622 140.045 80.9482 139.476 81.6032L139.43 81.6551L139.432 81.6548Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_780_1090",
    x1: 121.63,
    y1: 89.2057,
    x2: 167.479,
    y2: 76.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_780_1090",
    x1: 153.76,
    y1: 112.708,
    x2: 156.447,
    y2: 111.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_780_1090",
    x1: 152.316,
    y1: 118.204,
    x2: 153.861,
    y2: 117.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_780_1090",
    x1: 157.379,
    y1: 120.156,
    x2: 159.724,
    y2: 119.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_780_1090",
    x1: 153.805,
    y1: 123.76,
    x2: 155.35,
    y2: 123.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_780_1090",
    x1: 159.439,
    y1: 133.767,
    x2: 161.602,
    y2: 133.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_780_1090",
    x1: 159.647,
    y1: 125.906,
    x2: 163.373,
    y2: 124.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_780_1090",
    x1: 140.486,
    y1: 150.389,
    x2: 188.016,
    y2: 137.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E5DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3103,
    stopColor: "#0F4EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9631,
    stopColor: "#1026A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10249F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_780_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 162.406,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_780_1090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8356,
    height: 141.832,
    fill: "white",
    transform: "translate(103 33.4866) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.1f1dd7eee14504f207c04a4391fedf99.svg";
export { ForwardRef as ReactComponent };